import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/api";

export const WhatsAppFloat = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float-btn"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-4 py-3 bg-[#25D366] text-white font-semibold text-sm rounded-full shadow-lg hover:shadow-xl hover:bg-[#1fb857] hover:scale-105 transition-all duration-200"
  >
    <MessageCircle size={20} />
    <span className="hidden sm:inline">Chat with us</span>
  </a>
);
